import Container from "react-bootstrap/Container";
import { Card, Form, Row, Col } from "react-bootstrap";
import logo from "../images/logo.webp";
import DateRangeComp from "./DateRangeComp";
import Button from "react-bootstrap/Button";
import React, { useState,useEffect } from "react";
import { Scrollbars } from "react-custom-scrollbars";
import Slider from "react-slick";
import LeadsByMonthGraph from "../Grpahs/LeadsByMonthGraph";
import Table from "react-bootstrap/Table";
import PaymentMade1 from "../database/PaymentMade1.json";

import RadialBarChart from "../Grpahs/RadialBarChart";

// db imports
// import db from "../database/db.json";
// import db1 from "../database/db1.json";
// import YearToDateVisualGraph from "../Grpahs/YearToDateVisualGraph";
import ActiveUniqueDealsByDesti from "../database/ActiveUniqueDealsByDesti.json";
import RadialBarHighChart from "../Grpahs/RadialBarHighChart";
import Header from "./Header";

export const ActiveUniqueDetails = () => {
  let color = ["#093603", "#410459", "#c2081a", "#08d12d", "#114ef5"];

  const [todos] = useState(color);

  let labels = [
    "United States",
    "Ireland",
    "Canada",
    "United Kingdom",
    "Australia",
  ];

  const [label] = useState(labels);


  const [add,setAdd]=useState(0);


  useEffect(()=>{
    userAdd();

  },[])


  function userAdd(){
    const rec = PaymentMade1
    var sum=0;
      for(var i=0; i<rec.length; i++){
        sum += parseInt(rec[i].PaymentMode)
      }
      setAdd(sum)
    }

  var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
  };

  // const percentage= (value * 100) / maxValue;
  // var json = JSON.parse(ActiveUniqueDealsByDesti);
  // alert(JSON.stringify(ActiveUniqueDealsByDesti));

  const data=JSON.stringify(ActiveUniqueDealsByDesti)
  function handleJson(ActiveUniqueDealsByDesti){
    let label=[]
    let y=[]
    ActiveUniqueDealsByDesti.forEach((ele)=>{
      label.push(ele.label)
      y.push(ele.y)
    })
    return {label:label , y:y}
  }

  return (
    <React.Fragment>
    <Header/>
      <Container fluid style={{ height: "80%" }}>
        <Row>
          <Col>
            <Container fluid>
              <Row>
                <Col xs={6} style={{ display: "flex", alignItems: "center" }}>
                  <img
                    src={logo}
                    className="d-inline-block align-top"
                    alt="logo"
                  />
                  <h2 style={{ fontSize: "40px" }}>
                    <strong>&nbsp; Active Unique Deals</strong>
                  </h2>
                </Col>

                <Col xs={3}>
                  <Card
                    className="text-center"
                    style={{
                      boxShadow: "2px 2px 8px ",
                      position: "initial",

                      width: "220px",
                      marginTop: "3px",
                      marginLeft: "52px",
                    }}
                  >
                    <Card.Header
                      style={{ backgroundColor: "black", color: "white" }}
                    >
                      Total Unique Applications
                    </Card.Header>
                    <Card.Body
                      style={{ paddingTop: "6px", textAlign: "center" }}
                    >
                      <h1>903</h1>
                    </Card.Body>
                  </Card>
                </Col>

                <Col xs={3}>
                  <Card
                    className="text-center"
                    style={{
                      // position:'initial',

                      width: "210px",
                      boxShadow: "2px 2px 8px ",
                      marginTop: "3px",
                      height: "125px",
                    }}
                  >
                    <Card.Header
                      style={{ color: "white", backgroundColor: "black" }}
                    >
                      Total Applications
                    </Card.Header>
                    <Card.Body style={{ paddingTop: "1px" }}>
                      <DateRangeComp />
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </Container>
          </Col>
        </Row>
        <Row>
          <Col>
            <hr
              style={{
                position: "initial",
                height: "4px",
                borderWidth: "0",
                color: "black",
                backgroundColor: "black",
                marginTop: "7px",
                marginBottom: "5px",
              }}
            ></hr>
          </Col>
        </Row>
        <Row>
          <Col xs={2}>
            <Card style={{ boxShadow: "2px 2px 8px ", position: "initial" }}>
              <Card.Header style={{ color: "white", backgroundColor: "black" }}>
                Select User
              </Card.Header>
              <Card.Body style={{ paddingTop: "0px", paddingBottom: "8px" }}>
                <Form.Select
                  aria-label="Default select example"
                  style={{ border: "none" }}
                >
                  <option>All</option>
                  <option value="1">One</option>
                  <option value="2">Two</option>
                  <option value="3">Three</option>
                </Form.Select>
              </Card.Body>
            </Card>
          </Col>

          <Col xs={2}>
            <Card style={{ boxShadow: "2px 2px 8px ", position: "initial" }}>
              <Card.Header style={{ color: "white", backgroundColor: "black" }}>
                Select Branch
              </Card.Header>
              <Card.Body style={{ paddingTop: "0px", paddingBottom: "8px" }}>
                <Form.Select
                  aria-label="Default select example"
                  style={{ border: "none" }}
                >
                  <option>All</option>
                  <option value="1">One</option>
                  <option value="2">Two</option>
                  <option value="3">Three</option>
                </Form.Select>
              </Card.Body>
            </Card>
          </Col>
          <Col xs={3}>
            <Card
              style={{
                boxShadow: "2px 2px 8px ",
                paddingTop: "0px",
                paddingBottom: "8px",
                position: "initial",
              }}
            >
              <Card.Header style={{ color: "white", backgroundColor: "black" }}>
                Select Destination
              </Card.Header>
              <Card.Body style={{ paddingTop: "0px", paddingBottom: "0px" }}>
                <Form.Select
                  aria-label="Default select example"
                  style={{ border: "none" }}
                >
                  <option>All</option>
                  <option value="1">One</option>
                  <option value="2">Two</option>
                  <option value="3">Three</option>
                </Form.Select>
              </Card.Body>
            </Card>
          </Col>

          <Col xs={2}>
            <Card
              style={{
                boxShadow: "2px 2px 8px ",
                paddingTop: "0px",
                paddingBottom: "8px",
                position: "initial",
              }}
            >
              <Card.Header style={{ color: "white", backgroundColor: "black" }}>
                Select Month
              </Card.Header>
              <Card.Body style={{ paddingTop: "0px", paddingBottom: "0px" }}>
                <Form.Select
                  aria-label="Default select example"
                  style={{ border: "none" }}
                >
                  <option>All</option>
                  <option value="1">One</option>
                  <option value="2">Two</option>
                  <option value="3">Three</option>
                </Form.Select>
              </Card.Body>
            </Card>
          </Col>
          <Col xs={3}>
          <Card style={{ boxShadow: "2px 2px 8px "}}>
          <Card.Header style={{ color: "white", backgroundColor: "black" }}>
            Select Year
          </Card.Header>
          <Card.Body style={{ paddingTop: "0px", paddingBottom: "0px" }}>
            
            <Slider {...settings} className='slider' style={{margin:'1px'}}>
               
                <div>
                  <Button variant="secondary">2020</Button>
                </div>
                <div>
                  <Button variant="secondary">2021</Button>
                </div>
                <div>
                  <Button variant="secondary">2022</Button>
                </div>
                
                  
                
              </Slider>
            
          </Card.Body>
        </Card>
          </Col>
        </Row>
        <Row style={{ paddingTop: "5px" }}>
          <Col xs={6}>
            <Card style={{ height: "96%", position: "initial",boxShadow: "2px 2px 8px " }}>
              <Card.Header style={{ backgroundColor: "black", color: "white" }}>
                Payment Made By Destination
              </Card.Header>
              <Card.Body style={{padding:'10px'}}>
              
                <RadialBarHighChart
                  height="360"
                  color={todos}
                  labels={ handleJson(ActiveUniqueDealsByDesti).label}
                  db={ handleJson(ActiveUniqueDealsByDesti).y}
                  graphType="radialBar"
                />
              </Card.Body>
            </Card>
          </Col>

          <Col xs={3}>
            <Card
              style={{
                height: "445px",
                boxShadow: "2px 2px 8px ",
                position: "initial",
              }}
            >
              <Card.Title
                style={{
                  textAlign: "center",
                  textDecoration: "underline 2px",
                  marginBottom: "0px",
                }}
              >
                <strong>
                  Top 5 Universities with Highest Number of Applicationd
                </strong>
              </Card.Title>
              <Card.Body className="intrest" style={{ padding: "5px" }}>
                <Scrollbars style={{ height: "100%", width: "100%" }}>
                  <div style={{ paddingRight: "15px" }}>
                    <Card>
                      <Card.Body style={{ padding: "1px 10px" }}>
                        <Card.Subtitle>Australia</Card.Subtitle>
                        <Card.Subtitle>6456</Card.Subtitle>
                        <Card.Text>Lead</Card.Text>
                      </Card.Body>
                    </Card>
                    <Card>
                      <Card.Body style={{ padding: "1px 10px" }}>
                        <Card.Subtitle>Australia</Card.Subtitle>
                        <Card.Subtitle>6456</Card.Subtitle>
                        <Card.Text>Lead</Card.Text>
                      </Card.Body>
                    </Card>
                    <Card>
                      <Card.Body style={{ padding: "1px 10px" }}>
                        <Card.Subtitle>Australia</Card.Subtitle>
                        <Card.Subtitle>6456</Card.Subtitle>
                        <Card.Text>Lead</Card.Text>
                      </Card.Body>
                    </Card>
                    <Card>
                      <Card.Body style={{ padding: "1px 10px" }}>
                        <Card.Subtitle>Australia</Card.Subtitle>
                        <Card.Subtitle>6456</Card.Subtitle>
                        <Card.Text>Lead</Card.Text>
                      </Card.Body>
                    </Card>
                    <Card>
                      <Card.Body style={{ padding: "1px 10px" }}>
                        <Card.Subtitle>Australia</Card.Subtitle>
                        <Card.Subtitle>6456</Card.Subtitle>
                        <Card.Text>Lead</Card.Text>
                      </Card.Body>
                    </Card>
                    <Card>
                      <Card.Body style={{ padding: "1px 10px" }}>
                        <Card.Subtitle>Australia</Card.Subtitle>
                        <Card.Subtitle>6456</Card.Subtitle>
                        <Card.Text>Lead</Card.Text>
                      </Card.Body>
                    </Card>
                    <Card>
                      <Card.Body style={{ padding: "1px 10px" }}>
                        <Card.Subtitle>Australia</Card.Subtitle>
                        <Card.Subtitle>6456</Card.Subtitle>
                        <Card.Text>Lead</Card.Text>
                      </Card.Body>
                    </Card>
                    <Card>
                      <Card.Body style={{ padding: "1px 10px" }}>
                        <Card.Subtitle>Australia</Card.Subtitle>
                        <Card.Subtitle>6456</Card.Subtitle>
                        <Card.Text>Lead</Card.Text>
                      </Card.Body>
                    </Card>
                    <Card>
                      <Card.Body style={{ padding: "1px 10px" }}>
                        <Card.Subtitle>Australia</Card.Subtitle>
                        <Card.Subtitle>6456</Card.Subtitle>
                        <Card.Text>Lead</Card.Text>
                      </Card.Body>
                    </Card>
                  </div>
                </Scrollbars>
              </Card.Body>
            </Card>
          </Col>

          <Col xs={3}>
            <Card style={{boxShadow: "2px 2px 8px ",}}>
              <Card.Body style={{ height: "443px" }}>
                <Table hover style={{ height: "300px" }}>
                  <thead style={{ backgroundColor: "black", color: "white" }}>
                    <tr style={{padding:'5px'}}>
                      <th>Month</th>
                      <th>Payment Mode</th>
                    </tr>
                  </thead>
                  <tbody>
                    {PaymentMade1.map((val, key) => {
                      return (
                        <tr key={key} >
                          <td style={{padding:'3px'}}>{val.Month}</td>
                          <td>{val.PaymentMode}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                  <tr style={{backgroundColor:'Highlight',boxShadow: "2px 2px 8px "}}>
                    <td style={{fontFamily:'cursive'}}>Total</td>
                    <td style={{fontFamily:'cursive'}}>{add}</td>
                  </tr>
                </Table>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </React.Fragment>
  );
};

export default ActiveUniqueDetails;
